module.exports = __webpack_public_path__ + "img/114.c2d7b8f1.jpg";